export default __webpack_public_path__ + "static/media/banner_375x500_DM_medio.f30699e8.png";